import * as mocks from '../../mocks/pages';

class MockSectionsRepository {
    
    
    getSections(props){
        const c= Promise.resolve(mocks.getPages());
        return c;
    }

}
export default MockSectionsRepository;